import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 899;
    background-color: rgba(0,0,0,0.6);
    z-index: 200;
    display: none;

    &.opened {
        display: block;
    }
`;

export const Window = styled.div`
    display: flex;
    position: fixed;
    top: -500%;
    left: -500%;
    transform: translate3d(-50%, -50%, 0);
    width: 70%;
    height: 80%;
    max-height: 80%;
    background-color: #111;
    border: 1px solid #333;
    z-index: 899;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        top: calc(50% + 15px);
        left: 50%;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    background-color: #333;
    height: 30px;
    width: 100%;
`;

export const HeaderTitle = styled.div`
    padding-left: 5px;
    font-size: 14px;
    text-transform: uppercase;
    color: #fff;
    flex: 1;
`;

export const HeaderReset = styled.div`
    width: 10px;
    height: 10px;
    background-color: #d90;
    border-radius: 5px;
    margin-right: 5px;

    &:hover {
        background-color: #fb0;
    }
`;

export const ButtonBar = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #333;
    width: 100%;
    position: relative;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;
    
    &:not(:last-child) {
        margin-right: 10px;
    }
    
    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
`;

export const UploadButton = styled.label`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    &:not(:last-child) {
        margin-right: 10px;
    }

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
`;

export const ButtonSpace = styled.div`
    flex: 1;
`;

export const SheetWrap = styled.div`
    flex: 1;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 0;
`;

export const Resize = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 16px;
    height: 16px;
    cursor: se-resize;
    overflow: hidden;

    &:before {
        content: '';
        position: absolute;
        bottom: -8px;
        rigth: -8px;
        border: 10px solid transparent;
        border-top: 10px solid #777;
        transform: rotate3d(0,0,1, -45deg);
    }
`;

export const UploadInput = styled.input.attrs(props => ({
    type: 'file',
    multiple: false
}))`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;